export default function IFilter({
  width = 13,
  height = 13,
  color = '#252526',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M8.33325 10.3333C8.33325 10.5956 8.20975 10.8426 7.99991 11L5.46671 12.8997C5.31528 13.0133 5.11261 13.0318 4.94327 12.9473C4.77388 12.8626 4.66658 12.6894 4.66658 12.5V6.67122L0.105383 0.807292C-0.0118037 0.656624 -0.0330661 0.452097 0.0506951 0.280599C0.134597 0.109051 0.308947 0 0.499914 0H12.4999C12.6909 0 12.8652 0.109051 12.9491 0.280599C13.0329 0.452097 13.0116 0.656624 12.8944 0.807292L8.33325 6.67122V10.3333ZM5.66658 11.5L7.33325 10.2493V6.61458C7.33325 6.42927 7.39526 6.24914 7.50903 6.10286L11.4778 1H1.52205L5.4908 6.10286C5.60457 6.24914 5.66658 6.42927 5.66658 6.61458V11.5Z"
        fill={color}
      />
      <path
        d="M0.499914 0.5H12.4999L7.90346 6.40972C7.85796 6.46823 7.83325 6.54024 7.83325 6.61437V10.3333C7.83325 10.4383 7.78385 10.537 7.69991 10.6L5.16658 12.5V6.61437C5.16658 6.54024 5.14187 6.46823 5.09636 6.40972L0.499914 0.5Z"
        fill={color}
      />
    </svg>
  );
}
